import React from "react";
import SpinnerSvg from "./Spinner.svg";
import "./Spinner.css";

export function Spinner({ className = "", size = "s", ...props }) {
  return (
    <div className={`Spinner ${className} Spinner__size_${size}`} {...props}>
      <img src={SpinnerSvg} alt="Loading..." />
    </div>
  );
}

export default Spinner;
